import { trace } from 'rytm-helpers';
import { updateLinks } from './linksFix';

const onCollapseShow = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelCollapse) {
    trigger.innerHTML = trigger.dataset.labelCollapse;
  }
}
const onCollapseHide = (e) => {
  const trigger = getCollapseTrigger(e.target.id);
  if (trigger.dataset.labelExpand) {
    trigger.innerHTML = trigger.dataset.labelExpand;
  }
}
const getCollapseTrigger = (id) => {
  let trigger;
  if (id) {
    trigger = document.querySelector("a[href='#" + id + "']");
  }
  return trigger;
}

// ### Window update
export const windowUpdate = (e) => {
  updateLinks();
};
export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")];
  list.forEach((el) => {
    const parentDiv = el.parentNode;
    parentDiv.removeChild(el);
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv);
  })
}

// ### INIT
export const initCommon = () => {
  document.documentElement.addEventListener("show.bs.collapse", onCollapseShow);
  document.documentElement.addEventListener("hide.bs.collapse", onCollapseHide);
  window.addEventListener('resize', windowUpdate);
  document.addEventListener('DOMContentLoaded', windowUpdate);
  // window update
  windowUpdate();
};

